import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {BsWhatsapp} from "react-icons/bs";
import {MdOutlineSecurity} from "react-icons/md";
import DivDiagonal from "../../components/DivDiagonal";
import {TradingWrapper, ContentArea} from "../Trading/styles";
import mercadoPagoFormasPagamentoIMG from "../../assets/img/mercadoPagoFormasPagamento.webp";
import messageTypes from "../../constants/MessagesTypes";
import {handleWhatsAppClick} from "../../utils/suport";
import CustomButton from "../../components/Form/Button";
import * as S from "./styles";

function PlansValueLineContent({t}) {
    const raw = t("plans_value_line");
    const parts = raw
        .split(/\s*[·•]\s*/)
        .map((s) => s.trim())
        .filter(Boolean);
    if (parts.length >= 2) {
        return (
            <S.PlansValueLineList>
                {parts.map((text, i) => (
                    <li key={i}>{text}</li>
                ))}
            </S.PlansValueLineList>
        );
    }
    return <S.PlansValueLine>{raw}</S.PlansValueLine>;
}

export default function Plans() {
    const {t} = useTranslation();
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    async function handleNewSignature(type) {
        try {
            setLoading(true);
            const types = ["FREE", "SEMIANNUAL", "YEARLY"];
            if (!types.includes(type)) {
                setLoading(false);
                return;
            }

            if (type === "FREE") {
                history.push("/dashboard");
                return;
            }

            history.push(`/plans/payment?type=${type}`);
        } catch (err) {
            setLoading(false);
            toast.error(messageTypes.ERROR_SIGNATURE);
        }
    }

    return (
        <TradingWrapper>
            <DivDiagonal shortMobileGradient/>
            <ContentArea>
                <S.PlansPageInner>
                    <S.PlansPageHeader>
                        <h1>
                            <i className="fas fa-gem" aria-hidden="true"/>
                            {" "}{t("plans_page_title")}
                        </h1>
                    </S.PlansPageHeader>

                    <S.PlansHero>
                        <S.PlansBadgeWrap>
                            <S.PlansBadge>{t("plans_page_badge")}</S.PlansBadge>
                        </S.PlansBadgeWrap>
                        <S.PlansHeroMobileStack>
                            <S.PlansHeroSubtitleSlot>
                                <S.PlansSubtitle>{t("plans_page_subtitle")}</S.PlansSubtitle>
                            </S.PlansHeroSubtitleSlot>
                            <S.PlansHeroValueSlot>
                                <PlansValueLineContent t={t}/>
                            </S.PlansHeroValueSlot>
                        </S.PlansHeroMobileStack>
                    </S.PlansHero>

                    <S.PlansGrid>
                        <S.PlanCardSemestralSlot>
                            <S.PlanTitle>{t("plans_semestral_title")}</S.PlanTitle>
                            <S.PlanTagline>{t("plans_semestral_tagline")}</S.PlanTagline>
                            <S.PlanPriceBlock>
                                <S.PlanPriceRow>
                                    <S.PlanCurrency>{t("plans_currency")}</S.PlanCurrency>
                                    <S.PlanAmount>{t("plans_semestral_price_value")}</S.PlanAmount>
                                    <S.PlanPeriod>{t("plans_price_suffix")}</S.PlanPeriod>
                                </S.PlanPriceRow>
                                <S.PlanTotal>{t("plans_semestral_total")}</S.PlanTotal>
                                <S.PlanSaveSpacer aria-hidden="true"/>
                            </S.PlanPriceBlock>
                            <S.PlanCtaOutline>
                                <CustomButton
                                    variant="outlined"
                                    color="primary"
                                    type="button"
                                    loading={loading}
                                    disabled={loading}
                                    onClick={() => handleNewSignature("SEMIANNUAL")}
                                >
                                    {t("plans_semestral_cta")}
                                </CustomButton>
                            </S.PlanCtaOutline>
                        </S.PlanCardSemestralSlot>

                        <S.PlanCardYearlySlot>
                            <S.PlanRibbon>{t("plans_yearly_badge")}</S.PlanRibbon>
                            <S.PlanTitle>{t("plans_yearly_title")}</S.PlanTitle>
                            <S.PlanTagline>{t("plans_yearly_tagline")}</S.PlanTagline>
                            <S.PlanPriceBlock>
                                <S.PlanPriceRow>
                                    <S.PlanCurrency>{t("plans_currency")}</S.PlanCurrency>
                                    <S.PlanAmount>{t("plans_yearly_price_value")}</S.PlanAmount>
                                    <S.PlanPeriod>{t("plans_price_suffix")}</S.PlanPeriod>
                                </S.PlanPriceRow>
                                <S.PlanTotal>{t("plans_yearly_total")}</S.PlanTotal>
                                <S.PlanSave>{t("plans_yearly_save")}</S.PlanSave>
                            </S.PlanPriceBlock>
                            <S.PlanCtaPrimary>
                                <CustomButton
                                    variant="contained"
                                    type="button"
                                    loading={loading}
                                    disabled={loading}
                                    onClick={() => handleNewSignature("YEARLY")}
                                >
                                    {t("plans_yearly_cta")}
                                </CustomButton>
                            </S.PlanCtaPrimary>
                        </S.PlanCardYearlySlot>
                    </S.PlansGrid>

                    <S.PlansSupportBanner>
                        <span>{t("plans_support_banner")}</span>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                handleWhatsAppClick(t("plans_support_whatsapp_prefill"));
                            }}
                        >
                            <BsWhatsapp size={22} color="#25D366"/>
                            {t("plans_support_cta")}
                        </a>
                    </S.PlansSupportBanner>

                    <S.PlansTrustBlock>
                        <h3>
                            <MdOutlineSecurity aria-hidden="true"/>
                            {t("plans_trust_title")}
                        </h3>
                        <p>{t("plans_trust_subtitle")}</p>
                        <img
                            src={mercadoPagoFormasPagamentoIMG}
                            alt=""
                        />
                    </S.PlansTrustBlock>

                    <S.PlansLegal>{t("plans_legal_payment")}</S.PlansLegal>

                    <S.PlansFooterContact>
                        <div>
                            {t("plans_contact_intro")}{" "}
                            <a
                                href="/"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleWhatsAppClick();
                                }}
                            >
                                <BsWhatsapp color="#25D366"/>{" "}
                                <u>{t("plans_contact_whatsapp")}</u>
                            </a>
                        </div>
                        <div className="email-line">
                            {t("plans_contact_email_label")}{" "}
                            <b>{t("plans_contact_email")}</b>
                        </div>
                    </S.PlansFooterContact>
                </S.PlansPageInner>
            </ContentArea>
        </TradingWrapper>
    );
}
